export default __webpack_public_path__ + "static/media/client-10.dbb4d5c8.png";